import validate from 'validate.js'
import '../typedefs'

/**
 * Validates createReply payload
 * @param {Reply} payload prayer request reply payload
 */
export function validateCreateReply (payload) {
  if (!validate.isObject(payload)) {
    throw new TypeError(`Function "createReply" expected paylaod of type "object", but got ${typeof payload}`)
  }

  const contraints = {
    message: {
      type: 'string',
      presence: true
    },
    requestPostId: {
      type: 'string',
      presence: true
    }
  }

  const invalid = validate(payload, contraints)

  if (invalid) {
    throw new Error(JSON.stringify(invalid))
  }

  return true
}
